<script>
export default {
    name: "PrintGeneralLedger",

    data() {

        return {
            ledgerItems: [],
        };
    },

    computed: {

        totalDebit() {
            if(!this.ledgerItems.length) return 0;

            return this.ledgerItems.map(ledgerItem => parseFloat(ledgerItem.debit)).reduce((sum, debit) => sum + debit);
        },

        totalCredit() {
            if(!this.ledgerItems.length) return 0;

            return this.ledgerItems.map(ledgerItem => parseFloat(ledgerItem.credit)).reduce((sum, credit) => sum + credit);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchGeneralLedger(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },
    methods: {

        fetchGeneralLedger() {
            let url = `Accounting/GetGeneralLedger`;
                url += `?FromDate=${this.$route.query.from}`;
                url += `&ToDate=${this.$route.query.to}`;
                url += `&COAID=${this.$route.query.coaid}`;

            return this.$http.get(url).then(({ data }) => {
                this.ledgerItems = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full my-2 p-2">
            <h2 class="text-lg font-bold">General Ledger</h2>
        </div>
        <div class="w-full">
            <table class="table text-sm">
                <thead>
                    <tr>
                        <th class="p-tiny">No</th>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Account</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">Memo</th>
                        <th class="p-tiny">Debit</th>
                        <th class="p-tiny">Credit</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ledgerItem, idx) in ledgerItems" :key="idx">
                        <td class="p-tiny">{{ ledgerItem.txnNo }}</td>
                        <td class="p-tiny">{{ ledgerItem.date | dateFormat }}</td>
                        <td class="p-tiny">{{ ledgerItem.account }}</td>
                        <td class="p-tiny">{{ ledgerItem.description }}</td>
                        <td class="p-tiny">{{ ledgerItem.memo }}</td>
                        <td class="p-tiny">{{ ledgerItem.debit | numberFormat }}</td>
                        <td class="p-tiny">{{ ledgerItem.credit | numberFormat }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th class="p-tiny text-right" colspan="5">Total</th>
                        <th class="p-tiny">{{ $formatCurrency(totalDebit) }}</th>
                        <th class="p-tiny">{{ $formatCurrency(totalCredit) }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>